import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { CookiePolicyDialog } from "./CookiePolicyDialog";

export const CONSENT_KEY = "ac_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
    } catch (_) {
      setVisible(true);
    }
    const reopen = () => setVisible(true);
    window.addEventListener("cookie-consent-reset", reopen);
    return () => window.removeEventListener("cookie-consent-reset", reopen);
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(CONSENT_KEY, value);
    } catch (_) {}
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 inset-x-0 z-[90] px-4 pb-4 sm:px-6 sm:pb-6"
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Informativa breve sui cookie"
        >
          <div className="max-w-[900px] mx-auto bg-espresso/95 backdrop-blur-md text-crema border border-crema/15 rounded-sm p-5 sm:p-6 shadow-2xl">
            <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
              <div className="flex items-start gap-3 flex-1">
                <Cookie size={20} className="text-fuchsiabrand flex-shrink-0 mt-0.5" />
                <p className="text-xs sm:text-sm text-crema/80 leading-relaxed">
                  Questo sito usa solo cookie tecnici necessari al suo funzionamento:
                  nessun cookie di analisi o marketing. Proseguendo accetti l'uso dei
                  cookie tecnici. Dettagli nella{" "}
                  <CookiePolicyDialog>
                    <button
                      type="button"
                      data-testid="cookie-policy-link"
                      className="text-fuchsiabrand underline underline-offset-2 hover:text-crema transition-colors"
                    >
                      Cookie Policy
                    </button>
                  </CookiePolicyDialog>
                  .
                </p>
              </div>
              <div className="flex items-center gap-2.5 flex-shrink-0">
                <button
                  type="button"
                  onClick={() => choose("rejected")}
                  data-testid="cookie-reject"
                  className="px-5 py-2.5 rounded-full font-mono text-[11px] uppercase tracking-[0.15em] border border-crema/30 text-crema/80 hover:border-fuchsiabrand hover:text-fuchsiabrand transition-colors duration-300"
                >
                  Rifiuta
                </button>
                <button
                  type="button"
                  onClick={() => choose("accepted")}
                  data-testid="cookie-accept"
                  className="px-5 py-2.5 rounded-full font-mono text-[11px] uppercase tracking-[0.15em] bg-fuchsiabrand text-white hover:bg-magentadark transition-colors duration-300"
                >
                  Accetta
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
